import { defineReceiver } from '@drapejs/invoker';
import { fetchPage} from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';
import { getBrandsCacheKey } from '@/composables/useBrandsIndex';

import { isPageType } from '@/connectors/shared';

export const schedule = defineReceiver(
  fetchPage,
  async function (command, data) {
    if (!isPageType(data, 'BrandIndex')) {
      return data;
    }
    
    await this.invoke(batch.scheduleQuery, {
      cacheKey: getBrandsCacheKey(command.path),
      query: gql`
        brands {
            brandName: label
            slug
            imageId
        }`,
    });

    return data;
  }
);
